import React, { lazy, Suspense } from 'react';
import PropTypes from 'prop-types';

import './DateAnswer.less';

const DatePicker = lazy(() => import(/* webpackChunkName: "DatePicker" */ './DatePicker'));

export function DateAnswer({ error, isMobile, question }) {
  return (
    <Suspense fallback={<input className={`date_answer ${error ? 'error' : ''}`} />}>
      <DatePicker
        className={`date_answer ${error ? 'error' : ''}`}
        dateFormat="MM/dd/yyyy"
        id={question.question_id}
        isMobile={isMobile}
        maxDate={new Date(question.answer_max)}
        minDate={new Date(question.answer_min)}
        name="answer"
        placeholderText="mm/dd/yyyy"
        // required={!!question.is_required}
      />
    </Suspense>
  );
}

DateAnswer.propTypes = {
  error: PropTypes.string,
  isMobile: PropTypes.bool,
  question: PropTypes.shape({
    answer_max: PropTypes.string,
    answer_min: PropTypes.string,
    is_required: PropTypes.bool,
    question_id: PropTypes.number,
  }).isRequired,
};

DateAnswer.defaultProps = {
  error: '',
  isMobile: false,
};

export default DateAnswer;
